import withComponentName from '../../../../../decorators/withComponentName';

export function Severance() {
  return (
    <p>
      The Parties agree that, in the event that&nbsp;
      one or more of the provisions of this Contract&nbsp;
      for Services is found to be unlawful,&nbsp;
      invalid or otherwise unenforceable, that / those&nbsp;
      provisions shall be deemed severed from the remainder&nbsp;
      of this Contract for Services. The remainder of&nbsp;
      this Contract for Services shall be valid and enforceable.
    </p>
  );
}

export default withComponentName(Severance);
